var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("SeaExport.BatchChangeCompany"),
        width: "600px",
        "close-on-click-modal": false
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          staticClass: "cargo-form",
          attrs: { "label-width": "80px", "label-position": "left" }
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.LoadingPort") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "loadingPortCode",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Airport,
                          "callback-method-type": "value",
                          "default-value": _vm.form.loadingPortCode,
                          "callback-params": { key: "loadingPortCode" }
                        },
                        on: {
                          parentCallBack: function(obj) {
                            _vm.form.loadingPortCode = obj.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.PortOfDestination") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { flex: "1" },
                        attrs: {
                          no: "destinationPortCode",
                          filterable: "",
                          "select-type": _vm.selectTypeNames.basic_data_Airport,
                          "callback-method-type": "value",
                          "default-value": _vm.form.destinationPortCode,
                          "callback-params": { key: "destinationPortCode" }
                        },
                        on: {
                          parentCallBack: function(obj) {
                            _vm.form.destinationPortCode = obj.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesCompany") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "salesOffice",
                          "office-id": Number(_vm.form.salesOffice),
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.form.salesOffice = p.value
                            _vm.form.salesDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.OperationCompany") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "opOffice",
                          "office-id": Number(_vm.form.opOffice),
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opOffice = p.value
                            _vm.form.opDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesDepartment") } },
                    [
                      _c("cargo-department-new-select", {
                        attrs: {
                          no: "salesDepartment",
                          placeholder: " ",
                          enables: true,
                          "sales-id": Number(_vm.form.sales),
                          "office-id": Number(_vm.form.salesOffice),
                          "department-id": Number(_vm.form.salesDepartment)
                        },
                        on: {
                          change: function(p) {
                            _vm.departmentChargeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("SeaExport.OperationDepartment") }
                    },
                    [
                      _c("cargo-department-select", {
                        attrs: {
                          no: "opDepartment",
                          enables: true,
                          "office-id": Number(_vm.form.opOffice),
                          "department-id": Number(_vm.form.opDepartment),
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.form.opDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Sales") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "sales",
                          placeholder: " ",
                          "method-params": {
                            category: "role",
                            shape: "sales",
                            active: true
                          },
                          "default-value": _vm.form.sales || ""
                        },
                        on: {
                          change: function(p) {
                            _vm.salesChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Operation") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "op",
                          "method-params": {
                            officeId: _vm.form.opOffice,
                            category: "role",
                            shape: "op"
                          },
                          "default-value": _vm.form.op || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.opChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "csrOffice",
                          "office-id": Number(_vm.form.csrOffice),
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrOffice = p.value
                            _vm.form.csrDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.DocumentOffice") } },
                    [
                      _c("cargo-office-select", {
                        attrs: {
                          no: "dcOffice",
                          "office-id": Number(_vm.form.dcOffice),
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcOffice = p.value
                            _vm.form.dcDepartment = 0
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Message.Customer_Service") } },
                    [
                      _c("cargo-department-new-select", {
                        attrs: {
                          no: "csrDepartment",
                          enables: true,
                          "sales-id": Number(_vm.form.sales),
                          "office-id": Number(_vm.form.csrOffice),
                          "department-id": Number(_vm.form.csrDepartment),
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.form.csrDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("Message.Documentation_Department")
                      }
                    },
                    [
                      _c("cargo-department-select", {
                        attrs: {
                          no: "dcDepartment",
                          enables: true,
                          "office-id": Number(_vm.form.dcOffice),
                          "department-id": Number(_vm.form.dcDepartment),
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.form.dcDepartment = p.value
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.CustomerService") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "csr",
                          "method-params": { category: "role", shape: "csr" },
                          "default-value": _vm.form.csr || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.csrChangeHandler(p)
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Documents") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "dc",
                          "method-params": { category: "role", shape: "dc" },
                          "default-value": _vm.form.dc || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.useChangeHandler(
                              p,
                              "dc",
                              "dc",
                              "dcDepartment",
                              "dcOffice"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.SalesOfGoods") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "cargoSalesId",
                          "method-params": {
                            category: "role",
                            shape: "salesOfGoods"
                          },
                          "default-value": _vm.form.cargoSalesId || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.useChangeHandler(
                              p,
                              "salesOfGoods",
                              "cargoSalesId",
                              "cargoSalesDepartment",
                              "cargoSalesOffice"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.AirlinePerson2") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "planner",
                          "method-params": {
                            category: "role",
                            shape: "airline"
                          },
                          "default-value": _vm.form.planner || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.useChangeHandler(
                              p,
                              "airline",
                              "planner",
                              "plannerDepartment"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            { attrs: { gutter: 10 } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.FieldOperation") } },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "siteOP",
                          "method-params": {
                            category: "role",
                            shape: "siteOp"
                          },
                          "default-value": _vm.form.siteOP || "",
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.useChangeHandler(
                              p,
                              "siteOp",
                              "siteOP",
                              "siteOpDepartment"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("SeaExport.OverseaCustomerService")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        ref: "overseaOp",
                        attrs: {
                          no: "overseaOp",
                          "default-value": _vm.form.overseaOp || "",
                          "merge-load": true,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.useChangeHandler(
                              p,
                              "overseaOp",
                              "overseaOp",
                              "overseaOpDepartment"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isAddUserDefinedRoles,
                  expression: "isAddUserDefinedRoles"
                }
              ],
              attrs: { gutter: 10 }
            },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole1")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "userDefinedRoleId1",
                          "method-params": {
                            category: "role",
                            shape: "userDefinedRole1"
                          },
                          "default-value": _vm.form.userDefinedRoleId1 || "",
                          "merge-load": true,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.useChangeHandler(
                              p,
                              "userDefinedRole1",
                              "userDefinedRoleId1",
                              "userDefinedRoleDept1",
                              "userDefinedRoleOffice1"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_userDefinedRole2")
                      }
                    },
                    [
                      _c("cargo-user-select", {
                        attrs: {
                          no: "userDefinedRoleId2",
                          "method-params": {
                            category: "role",
                            shape: "userDefinedRole2"
                          },
                          "default-value": _vm.form.userDefinedRoleId2 || "",
                          "merge-load": true,
                          placeholder: " "
                        },
                        on: {
                          change: function(p) {
                            _vm.useChangeHandler(
                              p,
                              "userDefinedRole2",
                              "userDefinedRoleId2",
                              "userDefinedRoleDept2",
                              "userDefinedRoleOffice2"
                            )
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("p", [_vm._v(_vm._s(_vm.$t("SeaExport.NoteUseNumLast")))]),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", no: "ok" },
              on: { click: _vm.btnConfirm }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.ok")))]
          ),
          _c(
            "el-button",
            {
              on: {
                click: function($event) {
                  _vm.innerVisible = false
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }